import React from 'react'

import { useHistory, useParams } from 'react-router-dom'
import { Box, Button } from '@material-ui/core'

import { Container, LoadingFeedback, Page } from 'components'

import { ChangesManagementForm } from './components'

import { routes } from 'Routes'
import * as service from 'service'

import useFetch from 'hooks/useFetch'

const ChangesManagementShow = () => {
  const params = useParams()
  const history = useHistory()

  const changesManagementId = params.changesManagementId

  const { response, isLoading } = useFetch(
    service.dponet.changesManagement.get,
    {
      changesManagementId,
    },
  )

  const changesManagement = response?.data?.changesManagement

  return (
    <Page title="Visualisar Gestão de Mudanças">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ChangesManagementForm
          changesManagement={changesManagement}
          isShow={true}
        />
        <Box ml={2} mt={2} display="flex" justifyContent="flex-end">
          <Box pr={1}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => history.push(routes.changesManagement.all)}
            >
              Voltar
            </Button>
          </Box>
        </Box>
      </Container>
    </Page>
  )
}

export default ChangesManagementShow
